var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"button",class:[
    { '-outline' : _vm.outline },
    { '-large' : _vm.large },
    ("-" + _vm.variant) ],attrs:{"type":_vm.tag === 'button' ? 'button' : null,"to":_vm.to}},[_c('span',{staticClass:"button_background"}),_vm._v(" "),_c('span',{staticClass:"button_content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }